export const labelStyles = {
  marginBottom: '4px',
};
